export const SOURCING_PRICE_IN_CENTS = 19900;
export const SOURCING_DISCOUNT_PRICE_IN_CENTS = 19900;
